module.exports = __webpack_public_path__ + "static/media/09d.aad8f997.svg";